export default __webpack_public_path__ + "static/media/jgd.2d5e7126.webp";